__turbopack_context__.v({
  "blok-big-title": "CollectionPageBlok-module__2XwyPG__blok-big-title",
  "blok-subtitle": "CollectionPageBlok-module__2XwyPG__blok-subtitle",
  "blok-title": "CollectionPageBlok-module__2XwyPG__blok-title",
  "hero": "CollectionPageBlok-module__2XwyPG__hero",
  "hero__heading": "CollectionPageBlok-module__2XwyPG__hero__heading",
  "hero__subtitle": "CollectionPageBlok-module__2XwyPG__hero__subtitle",
  "mainImage": "CollectionPageBlok-module__2XwyPG__mainImage",
});
